import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { Store } from 'redux';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
import ProductInfoRequestProcessor from './nextit-request-processor-productinfo-aon';
import LiveChatState from '@alme/ui-web/modules/livechat-foundation/src/livechat-state';

export default class ProductInfo {
    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;
    _reqProc: ProductInfoRequestProcessor;

    constructor(settings: AlightCustomSettingsType, liveChatState: LiveChatState) {
        this._settings = settings;
        this._reqProc = new ProductInfoRequestProcessor(settings, liveChatState);
    }

    getRequestProcessor() {
        return this._reqProc;
    }
}



// WEBPACK FOOTER //
// ./modules/productinfo/productinfo.ts